import EventBus from "../../../../util/EventBus";
import Applet from "../../Applet";
import EnlilDetailDialog from "../../../../components/EnlilDetailDialog";

class ProjectPlanPhaseReferenceFormApplet extends Applet {
    state = {
        Name: "ProjectPlanPhaseReferenceFormApplet",
        Actions: {
            View: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "ProjectPlanPhaseMilestoneUSID",
                            },
                            {
                                id: "ParentUSID",
                            },
                            {
                                id: "ReferenceType",
                            },
                            {
                                id: "DocumentRevisionUSID",
                            },
                            {
                                id: "Comment",
                            }
                        ]
                    }
                ]
            },
            New: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "ProjectPlanPhaseMilestoneUSID",
                            },
                            {
                                id: "ParentUSID",
                            },
                            {
                                id: "ReferenceType",
                            },
                            {
                                id: "DocumentIDPlusRevision",
                            },
                            {
                                id: "Comment",
                            }
                        ]
                    }
                ]
            },
            Edit: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "ProjectPlanPhaseMilestoneUSID",
                            },
                            {
                                id: "ParentUSID",
                            },
                            {
                                id: "ReferenceType",
                            },
                            {
                                id: "DocumentIDPlusRevision",
                            },
                            {
                                id: "Comment",
                            }
                        ]
                    }
                ]
            },
            Delete: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "ProjectPlanPhaseMilestoneUSID",
                            },
                            {
                                id: "ParentUSID",
                            },
                            {
                                id: "ReferenceType",
                            },
                            {
                                id: "DocumentIDPlusRevision",
                            },
                            {
                                id: "Comment",
                            }
                        ]
                    }
                ]
            }
        },
        Layout: {
            totalWidth: "36em",
        },
        Controls: {
            ProjectPlanPhaseMilestoneUSID: {
                id: "ProjectPlanPhaseMilestoneUSID",
                enterpriseComponentAttribute: "ProjectPlanPhaseMilestoneUSID",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [],
                csp: {
                    label: "Milestone",
                    size: "small"
                },
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            },
            ParentUSID: {
                id: "ParentUSID",
                enterpriseComponentAttribute: "ParentUSID",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [],
                csp: {
                    label: "Parent",
                    size: "small"
                },
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            },
            ReferenceType: {
                id: "ReferenceType",
                enterpriseComponentAttribute: "ReferenceType",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [],
                csp: {
                    label: "Reference Type",
                    size: "small"
                },
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            },
            DocumentIDPlusRevision: {
                id: "DocumentIDPlusRevision",
                enterpriseComponentAttribute: "DocumentIDPlusRevision",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [],
                csp: {
                    label: "Document",
                    size: "small"
                },
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            },
            Comment: {
                id: "Comment",
                enterpriseComponentAttribute: "Comment",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [],
                csp: {
                    label: "Comment",
                    size: "small"
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
        }
    };

    cancel() {
        super.cancel();

        if (this.props.defaultAction === "Edit") {
            EventBus.components.emit("project-plan-phase-reference-form-applet-cancel");
        } else {
            EventBus.components.emit("project-plan-phase-reference-form-applet-cancel");
        }
    };

    setAction(mode) {
        super.setAction(mode);

        if (mode === "Save Completed") {
            if (this.props.defaultAction === "Edit") {
                EventBus.components.emit("project-plan-phase-reference-form-applet-save");
            } else {
                EventBus.components.emit("project-plan-phase-reference-form-applet-save");
            }
        }
    };

    render() {
        return <EnlilDetailDialog applet={this}
                                layout={this.state.Layout}
                                controls={this.state.Controls}
                                actions={this.state.Actions}
                                title="Reference"
                                enterpriseComponent={this.getEnterpriseComponent()}
                                action={this.props.defaultAction}
                                errorReportingMethod="RealTime" />;
    }
}

export default ProjectPlanPhaseReferenceFormApplet;
